import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { fontFaces } from '../../../../assets/fonts/fonts';
import Logo from "../../../../styles/img/CompliNYC-Logo.png";
import toast from 'react-hot-toast';

/**
 * Generates a Property Service PDF report
 * @param {Array} buildingsData - Array of buildings with their service data
 * @param {string} clientName - Name of the client
 * @returns {Promise<jsPDF>} - PDF document
 */
export const generatePropertyServicePDF = async (buildingsData, clientName) => {
  console.log(buildingsData, clientName);
  if (!buildingsData || buildingsData.length === 0) {
    return toast.error("No buildings found for this Client");
    // throw new Error("Missing required data for PDF generation");
  }

  // Create PDF document
  const doc = new jsPDF();
  
  // Create table page
  await createPropertyServiceTablePage(doc, buildingsData, clientName);
  
  return doc;
};

/**
 * Creates a property service table page from HTML
 * @param {jsPDF} doc - The PDF document
 * @param {Array} buildingsData - Array of buildings with their service data
 * @param {string} clientName - Name of the client
 */
const createPropertyServiceTablePage = async (doc, buildingsData, clientName) => {
  // Define how many rows per page
  const ROWS_PER_PAGE = 10;
  
  // Calculate total pages needed
  const totalPages = Math.ceil(buildingsData.length / ROWS_PER_PAGE);
  
  // Process each page
  for (let pageNum = 0; pageNum < totalPages; pageNum++) {
    // If not the first page, add a new page
    if (pageNum > 0) {
      doc.addPage();
    }
    
    // Slice the data for current page
    const startIndex = pageNum * ROWS_PER_PAGE;
    const endIndex = Math.min(startIndex + ROWS_PER_PAGE, buildingsData.length);
    const currentPageData = buildingsData.slice(startIndex, endIndex);
    
    // Create a temporary div to hold our HTML
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "794px"; // A4 width in pixels at 96 DPI

    // Define SVG as a string
    const enableSvgString = `
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="27"
          height="27"
          rx="13.5"
          fill="#11B50C"
          stroke="#11B50C"
        />
        <path
          d="M11.3288 17.5161L8.20491 14.0016C8.08604 13.8677 7.91884 13.7865 7.7401 13.7758C7.56136 13.7652 7.38572 13.826 7.25181 13.9449C7.1179 14.0637 7.0367 14.2309 7.02606 14.4097C7.01543 14.5884 7.07624 14.7641 7.19511 14.898L10.7951 18.948C10.8562 19.0167 10.9307 19.0723 11.0141 19.1112C11.0975 19.1501 11.1879 19.1716 11.2798 19.1743C11.3718 19.177 11.4633 19.1608 11.5488 19.1269C11.6343 19.0929 11.712 19.0418 11.777 18.9768L21.227 9.52676C21.3462 9.39881 21.4111 9.22956 21.4081 9.05469C21.405 8.87982 21.3341 8.71298 21.2105 8.5893C21.0868 8.46563 20.9199 8.39479 20.7451 8.39171C20.5702 8.38862 20.401 8.45353 20.273 8.57276L11.3288 17.5161Z"
          fill="white"
        />
      </svg>
    `;
    
    // Create HTML content for property service table page
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        table {
          border-collapse: collapse;
          width: 100%;
          border: 1px solid #E5E7EC;
          border-radius: 8px;
          box-shadow: 0px 12px 23px 0px #3E49540A;
        }
        
        th, td {
          padding: 12px;
          text-align: left;
        }

        thead {
          background-color: #F5F5F9;
          border-radius: 8px 8px 0 0;
        }
        
        th {
          
          color: #1B3E61;
          font-family: "segoe_uisemibold";
          font-size: 14px;  
        
        }
        
        tr:nth-child(even) {
          background-color: #F9FAFB;
        }
        
        .service-check {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      </style>
      <div style="width: 794px; height: 1123px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
      <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
      <img src="${Logo}" style="width: 180px;">
      </div>
        <!-- Title -->
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">PROPERTY SERVICE REPORT</h1>
        </div>
        
        <!-- Horizontal line -->
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        
        <!-- Client Name -->
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 18px; margin: 0; font-family: 'Segoe UI Regular';">Client: <span style="font-family: 'segoe_uisemibold';">${clientName}</span></p>
        </div>
        
        <!-- Page indicator -->
        <div style="text-align: right; margin-bottom: 10px;">
          <p style="color: #637381; font-size: 12px; font-family: 'Segoe UI Regular';">Page ${
            pageNum + 1
          } of ${totalPages}</p>
        </div>
        
        <!-- Table -->
        <table style="width: 100%; margin-top: 10px; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="width: 5%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">#</th>
              <th style="width: 36%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">Building</th>
              <th style="width: 10%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">#Units</th>
              <th style="width: 9%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">Annual</th>
              <th style="width: 9%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">LL55</th>
              <th style="width: 12%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">HPD Alert</th>
            </tr>
          </thead>
          <tbody>
            ${currentPageData
              .map(
                (building, index) => `
               <tr>
                <td style="padding: 12px; font-family: 'Segoe UI Regular';">${
                  startIndex + index + 1
                }</td>
                <td style="padding: 12px; font-family: 'Segoe UI Regular';">${
                  building.address
                }</td>
                <td style="padding: 12px; text-align: center; font-family: 'Segoe UI Regular';">${
                  building.units
                }</td>
                <td style="padding: 12px; text-align: center;">
                  ${
                    building.services.annual
                      ? `<div class="service-check">${enableSvgString}</div>`
                      : ""
                  }
                </td>
                <td style="padding: 12px; text-align: center;">
                  ${
                    building.services.ll55
                      ? `<div class="service-check">${enableSvgString}</div>`
                      : ""
                  }
                </td>
                <td style="padding: 12px; text-align: center;">
                  ${
                    building.services.hpdAlert
                      ? `<div class="service-check">${enableSvgString}</div>`
                      : ""
                  }
                </td>
               </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        
       
      </div>
    `;
    
    // Add the div to the document
    document.body.appendChild(tempDiv);
    
    try {
      // Wait for fonts to load
      await document.fonts.ready;
      
      // Convert HTML to canvas
      const canvas = await html2canvas(tempDiv, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          // This function is called with the cloned document
          // You can use it to ensure fonts are loaded in the clone
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      
      // Add the canvas image to the PDF
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 210, 297); // A4 size in mm
    } catch (error) {
      console.error("Error generating HTML to PDF:", error);
    } finally {
      // Clean up
      document.body.removeChild(tempDiv);
    }
  }
  
  // Handle case when there's no data
  if (buildingsData.length === 0) {
    // Create a temporary div for empty state
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "794px"; // A4 width in pixels at 96 DPI
    
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
      </style>
      <div style="width: 794px; height: 1123px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
       <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
      <img src="${Logo}" style="width: 180px;">
      </div>
        <!-- Title -->
        <div style="text-align: centre; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">PROPERTY SERVICE REPORT</h1>
        </div>
        
        <!-- Horizontal line -->
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        
        <!-- Client Name -->
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 18px; margin: 0; font-family: 'Segoe UI Regular';">Client: <span style="font-family: 'segoe_uisemibold';">${clientName}</span></p>
        </div>
        
        <!-- Empty state message -->
        <div style="text-align: center; margin-top: 100px;">
          <p style="color: #637381; font-size: 16px; font-family: 'Segoe UI Regular';">No buildings available for this client.</p>
        </div>
        
      </div>
    `;
    
    document.body.appendChild(tempDiv);
    
    try {
      await document.fonts.ready;
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 210, 297);
    } catch (error) {
      console.error("Error generating empty HTML to PDF:", error);
    } finally {
      document.body.removeChild(tempDiv);
    }
  }
}; 